import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAcademicDegree } from "./routeType";

const { key, getPath } = getApi("members.academicDegree.put");

type IExtractedRouteType =
  IMemberAcademicDegree["memberAcademicDegreeSingleUpdate"];

export type IPutMemberAcademicGroup = IPickMutation<IExtractedRouteType>;

const putMemberAcademicGroup: Fetcher<
  IPutMemberAcademicGroup["response"],
  IPutMemberAcademicGroup["variables"]
> = ({ memberId, academicDegreeId, ...data }) => {
  return axiosClient.put(getPath({ memberId, academicDegreeId }), data);
};

export const usePutMemberAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: putMemberAcademicGroup,
});
